import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

export interface CircleIconProps {}

export const CircleIcon = (_props: CircleIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 18.16 18.16">
      <path
        d="M9.08,0a9.08,9.08,0,1,0,9.08,9.08A9.09,9.09,0,0,0,9.08,0Zm0,17.025A7.945,7.945,0,1,1,17.025,9.08,7.954,7.954,0,0,1,9.08,17.025Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
